import * as yup from 'yup';

export type SiteDetailsFormData = {
  installationDate: string;
  name: string;
  address: string;
  voltageConfiguration: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  latitude: number;
  longitude: number;
  timezone: string;
  shouldHaveFlexibleExports: boolean | null;
  nmi: string | null;
  isConsumptionOnly: boolean;
};

export const siteDetailsFormSchema = yup.object().shape({
  installationDate: yup.string().required(),
  name: yup.string().required(),
  voltageConfiguration: yup.string().not(['0']).required(),
  address: yup.string().required('Site address is required.'),
});
